import { z } from "zod";

export const getIncomingInvoicePaymentRunParamsSchema = z.object({
	paymentRunId: z.string().min(1),
});

export type GetIncomingInvoicePaymentRunParamsSchema = z.infer<
	typeof getIncomingInvoicePaymentRunParamsSchema
>;
